import { memo } from 'react'
import { locales } from '../../../../locales/en'
import type { IconProps } from '../../../Icons'
import Bookmarked from '../../../Icons/Bookmarked'
import { palette } from '../../../styles/colors'
import Container from '../Container'

interface BookmarkBadgeProps extends IconProps {
    shadow?: boolean
    size?: number
}

const BookmarkBadge = memo((props: BookmarkBadgeProps) => {
    const { shadow, size = 0.8, ...other } = props

    return (
        <Container title="Bookmarked" shadow={shadow}>
            <Bookmarked
                title={locales.settings.pinToTop.bookmarks}
                color={palette.badgeBookmark}
                size={size}
                {...other}
            />
        </Container>
    )
})

export default BookmarkBadge
export { BookmarkBadge }
